import React, { useContext, useEffect, useState } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import * as icons from "react-bootstrap-icons";
import { Button, Col, Form, InputGroup, Row, Table } from "react-bootstrap";
import {
  AuctionGetAll,
  AuctionDelete,
  AuctionUpdate,
  SportAllMap,
  TeamGetAll,
  TournamentAll,
  UploadImage,
  WinCount,
  AuctionPlayPause,
  SportGetById,
  RefreshToken,
  TournamentGetByIdGet,
  debounce,
  AuctionGetAllData,
  AuctionGetAllDataSearch,
  AuctionPlaceBid,
} from "../../redux/auth-reducer/auth-service";
import { Footer } from "../../Footer";
import { ModalBox, ModalDelete } from "../Outer/Modal";
import { ToastContainer, toast } from "react-toastify";
import { ImageUrl, SignalRUrl } from "../../utils/config/config";
import { DatePicker, Loader } from "rsuite";
import dayjs from "dayjs";
import moment from "moment";
import * as signalR from "@microsoft/signalr";
import { Context } from "../../redux/Context";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import '../../../src/index.css'

export const Auction = () => {
  const [data, setData] = useState();
  const [itemList, setItemList] = useState("");
  const [searchText, setSearchText] = useState("");
  const [itemSport, setItemSport] = useState([]);
  const [count, setCount] = useState(0);
  const [deleteRow, setDeleteRow] = useState(0);
  const [showEdit, setShowEdit] = useState();
  const [validated, setValidated] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [imageName, setImageName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [tounamentItem, setTounamentItem] = useState([]);
  const [pause, setPause] = useState(false);
  const [playStatus, setPlayStatus] = useState({});
  const [page, setpage] = useState(1);
  const [auctionImage, setAuctionImage] = useState();
  const [teamFkID, setTeamFkID] = useState([]);
  const [dataImage, setDataImage] = useState();
  const [itemTeam, setItemTeam] = useState();
  const [selectedTournament, setSelectedTournament] = useState();
  const [secondryMarketStatus, setSecondryMarketStatus] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);
  const [number, setNumber] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [tournamentId, setTournamentId] = useState(null);
  const [auctionListWinner, setAuctionListWinner] = useState([]);
  const [fnDisabled, setFnDisabled] = useState(true);
  const [fields, setFields] = useState([]);
  const [counter, setCounter] = useState(0);
  const [allXcuttaPercentage, setAllXcuttaPercentage] = useState();
  const [winningPlaceInptData, setWinningPlaceInptData] = useState([]);
  const [sportIdSelect, setSportIdSelect] = useState();
  const [errorMessageXcutta, setErrorMessageXcutta] = useState(false);
  const [winingPlace, setWiningPlace] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [filterUpcoming, setFilterUpcoming] = useState([]);
  const [filterLive, setFilterLive] = useState([]);
  const [filterClosed, setFilterClosed] = useState([]);
  const [filterPaused, setFilterPaused] = useState([]);
  const [loading, setLoading] = useState(false);
  const [winnerCount, setWinnerCount] = useState(0);
  const [winners, setWinners] = useState([]);
  const [bracketStatus, setBracketStatus] = useState([]);
  const [winnerTitleList, setWinnerTitleList] = useState("");
  const [winnerPercentageList, setWinnerPercentageList] = useState([]);
  const [tournamentData, setTournamentData] = useState();
  const [combinedTeamsArray, setCombinedTeamsArray] = useState([]);
  const [showView, setShowView] = useState(false);
  const [totalRows, setTotalRows] = useState(1);
  const [auctionPlaceModal, setAuctionPlaceModal] = useState(false)
  const [auctionPlacedata, setAuctionPlaceData] = useState(null)

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];

  const [editData, setEditData] = useState({
    auctionId: 0,
    auctionName: "",
    auctionImage: "",
    tournamentId: 0,
    sportId: 0,
    teamId: 0,
    startDate: "",
    bidTime: 0,
    winnerCount: 0,
    winnerTitle: [],
    winnerPercentage: [],
    xcuttaTake: 0,
    secondaryMarket: true,
  });

  const { hubConnection } = useContext(Context);

  // const [hubConnection, setHubConnection] = useState(null);

  function sidebarfun() {
    setData(!data);
  }

  useEffect(() => {
    const SportAllFn = async () => {
      await SportAllMap().then((response) => {
        setItemSport(response?.data?.data?.dataList);
      });
    };
    SportAllFn();
  }, []);

  useEffect(() => {
    const SportByIDFn = async () => {
      await SportGetById(sportIdSelect).then((response) => {
        setBracketStatus(response?.data?.isBracket);
      });
    };
    SportByIDFn();
  }, [sportIdSelect]);

  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }
  const isUser = JSON.parse(localStorage.getItem("isUser"));

  const columns = [
    {
      name: <strong>Id</strong>,
      selector: (row, index) => index + 1,
    },

    {
      name: <strong>Auction Name</strong>,
      selector: (row) => row?.auctionName,
      sortable: true,
      width: "200px",
    },

    {
      name: <strong>Auction Image</strong>,
      selector: (row) =>
        // {
        //   row?.auctionImage == "" ? <img src="../image/auction.png" width={50} />:<img src={ImageUrl + row?.auctionImage} width={50} />
        // },
        {
          return !row?.auctionImage ? (
            <img src="../image/auction.png" className="m-2" width={50} />
          ) : (
            <img
              src={`${ImageUrl}${row.auctionImage}`}
              className="m-2"
              width={50}
            />
          );
        },

      sortable: true,
    },

    {
      name: <strong>Contest Name</strong>,
      selector: (row) => row?.tournamentName,
      sortable: true,
      width: "150px",
    },
    {
      name: <strong>Sport Name</strong>,
      selector: (row) =>
        itemSport?.map((value) => {
          if (value.sportId == row?.sportId) {
            return value.sportName;
          }
        }),
      sortable: true,
      width: "150px",
    },

    {
      name: <strong>Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
      sortable: true,
      width: "200px",
    },

    {
      name: <strong>Bid Time Limit</strong>,
      selector: (row) => row?.bidTime,
      sortable: true,
    },
    {
      name: <strong>Secondary Market</strong>,
      width: "200px",
      selector: (row) =>
        row?.secondaryMarket == true ? (
          <div className="bg-succ">Available</div>
        ) : (
          <div className="bg-dang">Unavailable</div>
        ),
      sortable: true,
      sortFunction: (a, b) => {
        const statusA = a.secondaryMarket ? "Available" : "Unavailable";
        const statusB = b.secondaryMarket ? "Available" : "Unavailable";
        return statusA.localeCompare(statusB);
      },
    },
    {
      name: <strong>Team</strong>,
      selector: (row) => (
        <>
          <button
            type="button"
            className="btn btn-primary viewButton"
            onClick={() => viewFn(row)}
          >
            {" "}
            <icons.Eye /> Team
          </button>
        </>
      ),
      sortable: true,
      width: "150px",
    },

    // PlaceBit details
    {
      name: <strong>Auction Winnings</strong>,
      selector: (row) => (
        <>
          <button
            type="button"
            className="btn btn-primary viewButton"
            onClick={() => viewPlacebit(row)}
          >
            {" "}
            <icons.Eye /> 
          </button>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: <strong>Bid Status</strong>,

      selector: (row) =>
        row?.status === "Upcoming" ? (
          <>
            <span style={{ color: "#f9c114" }}>Upcoming</span>
          </>
        ) : row.status === "Live" ? (
          <>
            <span style={{ color: "#043bc7" }}>Live</span>
          </>
        ) : row.status === "Paused" ? (
          <>
            <span style={{ color: "red" }}>Paused</span>
          </>
        ) : (
          <span style={{ color: "red" }}>Closed</span>
        ),
      sortable: true,
    },
    {
      name: <strong>Action</strong>,
      width: "200px",
      selector: (row) => (
        <>
          {row?.createdBy === isUser?.userId ? (
            <button
              type="button"
              className="text-danger btn-aucion"
              onClick={() => deleteFn(row?.auctionId)}
            >
              <icons.Trash />
            </button>
          ) : (
            <button
              type="button"
              disabled
              className="text-danger btn-aucion"
              onClick={() => deleteFn(row?.auctionId)}
            >
              <icons.Trash />
            </button>
          )}

          {row?.createdBy === isUser?.userId ? (
            <button
              type="button"
              className="text-success btn-aucion"
              onClick={() => editFn(row)}
              disabled={row.status !== "Upcoming"}
            >
              <icons.PencilSquare />
            </button>
          ) : (
            <button
              type="button"
              disabled
              className="text-success btn-aucion"
              onClick={() => editFn(row)}
            >
              <icons.PencilSquare />
            </button>
          )}

          {row.status === "Paused" ? (
            <button
              type="button"
              className="text-success btn-aucion"
              onClick={() => playPausefN(row)}
            >
              <icons.Play style={{ border: "2px solid" }} />
            </button>
          ) : (
            <button
              type="button"
              className="text-success btn-aucion"
              onClick={() => playPausefN(row)}
            >
              <icons.Pause style={{ border: "2px solid" }} />
            </button>
          )}
        </>
      ),
      sortable: true,
    },
  ];

  const viewFn = (viewItem) => {
    setShowView(true);
    setEditData(viewItem);
  };

  const viewPlacebit = async(item) => {
    const autionId  = item.auctionId
    const result = await AuctionPlaceBid(autionId)
    setAuctionPlaceData(result?.data)
    if(result){
      setAuctionPlaceModal(true)
    }
  }

  const handleAuctionPalceBitClosed = () => {
    setAuctionPlaceModal(false)
  }

  const updatePlayStatus = (auctionId, status) => {
    setPlayStatus((prevStatus) => ({
      ...prevStatus,
      [auctionId]: status,
    }));
    setPause(!pause);
  };

  const playPausefN = (row) => {
    const statusSend = row.status != "Paused" ? true : false;
    updatePlayStatus(row.auctionId, !playStatus[row.auctionId]);
    const AuctionPlayPauseStatus = async () => {
      await AuctionPlayPause(row.auctionId, statusSend).then((response) => {
        if (response?.data?.status === true) {
          setFilteredData((p) =>
            p.map((e) => {
              if (e.auctionId == row.auctionId) {
                return {
                  ...e,
                  status: row.status == "Paused" ? "Live" : "Paused",
                };
              } else {
                return e;
              }
            })
          );
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }
      });
    };
    AuctionPlayPauseStatus();
  };

  const updatedWinnerTitles = winnerTitleList;
  const updatedWinnerPercentages = winnerPercentageList;

  const handleUpdate = async () => {
    setValidated(true);

    // Calculate total percentage from winningPlaceInptData
    // let totalPer = winnerPercentageList.reduce((acc, item) => {
    //   item.input.forEach((elem) => {
    //     acc += Number(elem.winnerPercentage);
    //   });
    //   return acc;
    // }, 0);

    // Add xcuttaTake to totalPer
    const totalWinnerPercentage = winnerPercentageList.reduce(
      (acc, percentage) => acc + Number(percentage),
      0
    ); // Ensure each percentage is treated as a number

    // Get xcuttaTakePercentage and ensure it's a number
    const xcuttaTakePercentage = Number(editData?.xcuttaTake) || 0;

    // Calculate total with xcuttaTake
    const totalWithXcutta = totalWinnerPercentage + xcuttaTakePercentage;

    // Check if total percentage is not equal to 100
    if (totalWithXcutta !== 100) {
      toast.error("Total percentage including xcutta take must be 100%.");
      return; // Exit the function early
    }

    // Continue with the rest of the function if total percentage is valid
    let winnertitle = winners.map((winner) => winner.name);
    let winnerPercentage = winners.map((item) => Number(item.winnerPercentage));

    const newRegistration = combinedTeamsArray?.map((item) => item?.id);

    const updateData = auctionImage
      ? {
          crudOperationId: false,
          auctionId: editData?.auctionId,
          auctionName: editData?.auctionName,
          auctionImage: dataImage,
          tournamentId: selectedTournament.trim(),
          sportId: parseInt(sportIdSelect),
          teamId: newRegistration,
          startDate: editData?.startDate,
          xcuttaTake: xcuttaTakePercentage, // Use the xcuttaTake percentage
          bidTime: editData?.bidTime,
          startingBid: editData?.startingBid,
          bidIncrement: editData?.bidIncrement,
          winnerCount: editData?.winnerCount,
          winnerTitle: updatedWinnerTitles,
          winnerPercentage: filteredWinnerPercentages,
          secondaryMarket: secondryMarketStatus,
          isPrivate: editData?.isPrivate,
        }
      : {
          crudOperationId: false,
          auctionId: editData?.auctionId,
          auctionName: editData?.auctionName,
          auctionImage: editData?.auctionImage,
          tournamentId: selectedTournament.trim(),
          sportId: parseInt(sportIdSelect),
          teamId: newRegistration,
          startingBid: editData?.startingBid,
          bidIncrement: editData?.bidIncrement,
          startDate: editData?.startDate,
          xcuttaTake: xcuttaTakePercentage, // Use the xcuttaTake percentage
          bidTime: editData?.bidTime,
          winnerCount: editData?.winnerCount,
          winnerTitle: updatedWinnerTitles,
          winnerPercentage: filteredWinnerPercentages,
          secondaryMarket: secondryMarketStatus,
          isPrivate: editData?.isPrivate,
        };

    await AuctionUpdate(updateData).then((res) => {
      if (res?.status === true) {
        toast.success(res?.message);
        setShowEdit(false);
        setCount(count + 1);
      } else {
        toast.error(res?.message);
      }
    });
  };
  useEffect(() => {
    if (editData) {
      const auctionTeams =
        editData?.teamNames?.split(",").map((team) => team.trim()) || [];
      const auctionTeamsId =
        typeof editData?.teamId === "string"
          ? editData.teamId.split(",").map((team) => team.trim())
          : [];
      const auctionTeamsImageData =
        editData?.teamImages?.split(",").map((team) => team.trim()) || [];

      const combinedTeams =
        auctionTeams.map((teamName, index) => ({
          id: auctionTeamsId[index], // Get the corresponding ID
          name: teamName,
          image: auctionTeamsImageData[index], // Get the team image
        })) || [];

      setCombinedTeamsArray(combinedTeams);
    }

    // if (selectedTournament) {
    //   let auctionTeams = tournamentData?.auctionTeamsName
    //     ?.split(",")
    //     .map((team) => team.trim());
    //   let auctionTeamsId = tournamentData?.auctionTeams
    //     ?.split(",")
    //     .map((team) => team.trim());
    //   var auctionTeamsImageData = tournamentData?.auctionTeamsImage
    //     ?.split(",")
    //     .map((team) => team.trim());
    //   const combinedTeams =
    //     auctionTeams?.map((teamName, index) => ({
    //       id: auctionTeamsId[index], // Get the corresponding ID
    //       name: teamName,
    //       image: auctionTeamsImageData[index], // Get the team name
    //     })) || [];

    //   setCombinedTeamsArray(combinedTeams);
    // }
  }, [tournamentData]);

  var auctionTeamsImageData = editData?.teamImages
    ?.split(",")
    .map((team) => team.trim());

  const editFn = (row, e) => {
    const event = `${row?.sportId} - ${row.teamId} = ${row?.tournamentId}`;
    const [itemList, array, value] = event.split(/[-=]/);
    setTeamFkID(array.split(",").map((e) => parseInt(e)));
    setSelectedTournament(value);
    setSportIdSelect(itemList);
    setShowEdit(true);
    
    // Remove leading and trailing spaces from winner percentage values
    var valuesWinner = row?.winnerPercentage?.split(",").map(value => value.trim());
    var finalData = { ...row, winnerPercentage: valuesWinner };
    
    // Trim winner titles and convert percentages to numbers
    setWinnerTitleList(row.winnerTitle.split(",").map((title) => title.trim()));
    setWinnerPercentageList(row.winnerPercentage.split(",").map(value => Number(value.trim())));
    
    setEditData(finalData);
    setNumber(row?.winnerCount);
};

  useEffect(() => {
    if (selectedTournament) {
      const TournamentIDFn = async () => {
        const response = await TournamentGetByIdGet(selectedTournament);

        setTournamentData(response);
      };
      TournamentIDFn();
    }
  }, [selectedTournament]);

  useEffect(() => {
    // Initialize winner titles and percentages based on editData
    if (editData.winnerCount) {
      const titles = Array.from({ length: winnerCount }, (_, index) => {
        return winnerTitleList[index] || `Place ${index + 1}`; // Default title if not set
      });
      const percentages = Array.isArray(editData.winnerPercentage)
        ? editData.winnerPercentage
        : editData.winnerPercentage.split(",").map(Number);

      setWinnerTitleList(titles);
      setWinnerPercentageList(percentages);
      setWinnerCount(editData.winnerCount); // Set initial winner count
    }
  }, [editData, winnerCount]);

  useEffect(() => {
    // Update winnerTitleList and winnerPercentageList based on winnerCount
    const updatedTitles = Array.from({ length: winnerCount }, (_, index) => {
      return winnerTitleList[index] || `Place ${index + 1}`; // Default title if not set
    });

    const updatedPercentages = Array.from(
      { length: winnerCount },
      (_, index) => {
        return winnerPercentageList[index] || ""; // Default percentage if not set
      }
    );

    setWinnerTitleList(updatedTitles);
    setWinnerPercentageList(updatedPercentages);
  }, [winnerCount]);

  useEffect(() => {
    if (editData?.startDate) {
      var localTime = moment.utc(editData?.startDate).local().format();
      setStartDate(new Date(localTime));
    }
  }, [editData]);

  useEffect(() => {
    if (editData?.tournamentId) {
      setTournamentId(new Date(editData?.tournamentId));
    }
  }, [editData]);

  const handelEditSport = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };
  const deleteFn = (auctionId) => {
    setShowDeleteModal(true);
    setDeleteRow(auctionId);
  };
  const handleClosed = () => {
    setShowDeleteModal(false);
    setShowEdit(false);
    setShowView(false);
  };

  const handelDelete = async () => {
    await AuctionDelete(deleteRow).then((res) => {
      if (res?.status == true) {
        setCount(count + 1);
        toast.success(res?.message);

        setShowDeleteModal(!showDeleteModal);
      } else {
        toast.error(res?.message);
      }
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const AuctionAllFn = async (data) => {
    try {
      const response = await AuctionGetAllData(data); // Call your API function
      if (response?.data) {
        setItemList(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    AuctionAllFn(data); // Fetch data when currentPage changes
  }, [currentPage, count]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    AuctionAllFn(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };
  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    if (value.length === 1 && value === " ") {
      return; // Ignore the input if it's just a space
    }
    setSearchText(value);
    const data = {
      SearchTerm: value,
      SortOrder: false,
      SortColumn: "TeamName",
    };
    AuctionAllFnSearch(data);
  };

  const handelFrom = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };
  const handelAuctionTake = (e) => {
    setAllXcuttaPercentage(100 - e.target.value);

    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
    setErrorMessage(false);
    setErrorMessageXcutta(false);
  };

  const handelDate = async (date) => {
    setEditData({
      ...editData,
      startDate: date,
    });
  };

  const handelImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.onload = function (e) {
        setSelectedImage(e.target.result);
      };
      setAuctionImage(e.target.files[0].name);
      reader.readAsDataURL(e.target.files[0]);
    }
    setSelectedFile(e.target.files[0].name);
    setImageName(e.target.files[0].name);
    const dataList = e.target.files[0];
    const imageAPI = async () => {
      const formDataImage = new FormData();
      formDataImage.append("file", dataList);
      await UploadImage(formDataImage).then((res) => {
        if (res) {
          setDataImage(res?.data?.message);
        } else {
        }
      });
    };

    imageAPI();
  };

  useEffect(() => {
    const TeamAllFn = async () => {
      await TeamGetAll().then((response) => {
        setItemTeam(response?.data?.data?.dataList);
      });
    };
    TeamAllFn();
  }, []);

  useEffect(() => {
    const TournamentAllFn = async () => {
      await TournamentAll().then((response) => {
        setTounamentItem(response?.data?.data?.dataList);
      });
    };
    TournamentAllFn();
  }, []);

  const handleSelectedTurnament = (event) => {
    const [itemList, array, value] = event.target.value.split(/[-=]/);
    setSportIdSelect(itemList);
    setTeamFkID(array.split(",").map((e) => parseInt(e)));
    setSelectedTournament(value);
  };

  useEffect(() => {
    if (selectedTournament) {
      const auctionTeams = tournamentData?.auctionTeamsName
        ?.split(",")
        .map((team) => team.trim());
      const datateam = auctionTeams?.length;

      const AuctionWiningPlace = async () => {
        try {
          const response = await WinCount(datateam);
          setWiningPlace(response?.data);
        } catch (error) {
          console.error("Error fetching winning place:", error);
        }
      };

      if (datateam > 0) {
        AuctionWiningPlace();
      }
    }
  }, [selectedTournament, tournamentData]);

  useEffect(() => {
    const teamFkIDString = teamFkID.join(", ");
    let teamsLength = teamFkIDString.split(",").map((e) => parseInt(e)).length;
    if (teamsLength) {
      const AuctionWiningPlace = async () => {
        await WinCount(teamsLength).then((response) => {
          setWiningPlace(response?.data);
        });
      };
      AuctionWiningPlace();
    }
  }, [selectedTournament]);

  const handelCount = (e) => {
    const count = parseInt(e.target.value);

    setWinnerCount(count);
    setEditData({
      ...editData,
      winnerCount: count,
    });
  };

  useEffect(() => {
    let data = [];
    for (let i = 1; i <= number; i++) {
      let ordinal = i + getOrdinalSuffix(i) + " Place Winner (%)";
      data.push(ordinal);
    }
    setFields(data);
  }, [number]);

  let dateString = editData?.dateOfBirth;
  let date = new Date(dateString);
  if (!isNaN(date.getTime())) {
    let localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    var formattedDateOfBirth = localDate.toISOString().split("T")[0];
    let parts = formattedDateOfBirth.split("-");
  } else {
    console.error("Invalid date format");
  }

  const handleChangeOption = (event) => {
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
    if (searchText) {
      const filtered = itemList.filter((item) => {
        return (
          item?.auctionName?.toLowerCase().includes(searchText.toLowerCase()) ||
          item?.status?.toLowerCase().includes(searchText.toLowerCase()) ||
          item?.sportName?.toLowerCase().includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(itemList);
    }
  }, [searchText, itemList]);

  useEffect(() => {
    if (selectedOption === "live") {
      const filtered = filterLive.filter((item) =>
        item.status.toLowerCase().includes("live")
      );
      setFilteredData(filtered);
    } else if (selectedOption === "upcoming") {
      const filtered = filterUpcoming.filter((item) =>
        item.status.toLowerCase().includes("upcoming")
      );
      setFilteredData(filtered);
    } else if (selectedOption === "closed") {
      const filtered = filterClosed.filter((item) =>
        item.status.toLowerCase().includes("closed")
      );
      setFilteredData(filtered);
    } else if (selectedOption === "Paused") {
      const filtered = filterPaused.filter((item) =>
        item.status.toLowerCase().includes("paused")
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(itemList);
    }
  }, [selectedOption, itemList]);

  useEffect(() => {
    if (itemList) {
      const filterUpcomings = (eventArray) => {
        return eventArray.filter((event) => event.status === "Upcoming");
      };
      setFilterUpcoming(filterUpcomings(itemList));

      const filterLives = (eventArray) => {
        return eventArray.filter((event) => event.status === "Live");
      };
      setFilterLive(filterLives(itemList));

      const filterCloses = (eventArray) => {
        return eventArray.filter((event) => event.status === "Closed");
      };
      setFilterClosed(filterCloses(itemList));

      const filterPauses = (eventArray) => {
        return eventArray.filter((event) => event.status === "Paused");
      };
      setFilterPaused(filterPauses(itemList));
    }
  }, [itemList]);

  const textEdit = (str, index) => {
    setFields((prev) => {
      return prev?.map((e, i) => {
        if (i == index) {
          return str;
        } else {
          return e;
        }
      });
    });
  };
  const handleClick = () => {
    setFnDisabled(false);
    setFnDisabled(!fnDisabled);
  };

  const handleWinningPlaceChange = (index) => (event) => {
    const newPercentage = event.target.value;
    const updatedList = [...winnerPercentageList];
    updatedList[index] = newPercentage; // Update the specific index
    setWinnerPercentageList(updatedList); // Update the state
  };

  const handleTitleChange = (index) => (e) => {
    const newTitles = [...winnerTitleList];
    newTitles[index] = e.target.value;
    setWinnerTitleList(newTitles);
  };

  const getOrdinalSuffix = (number) => {
    const suffixes = ["th", "st", "nd", "rd"];
    const value = number % 100;
    return (
      number + (suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0])
    );
  };

  // const filteredWinnerPercentages = winnerPercentageList.slice(
  //   0,
  //   editData.winnerCount
  // );

const filteredWinnerPercentages = winnerPercentageList
  .slice(0, editData.winnerCount)
  .map(percentage => {
    return String(percentage).trim();
  });

  useEffect(() => {
    setWinnerPercentageList(Array(editData.winnerCount).fill("")); // Reset to empty strings
  }, [editData.winnerCount]);

  useEffect(() => {
    const newList = Array.from({ length: editData.winnerCount }, (_, index) => {
      return winnerPercentageList[index] || ""; // Keep previous values if they exist
    });
    setWinnerPercentageList(newList);
  }, [editData.winnerCount]);

  const updateTime = (time) => {
    const [minutesStr, secondsStr] = time?.split(":") ?? [0, 0];
    const updatedMinutes = parseInt(minutesStr, 10);
    let updatedSeconds = parseInt(secondsStr, 10);

    if (!isNaN(updatedMinutes) && !isNaN(updatedSeconds)) {
      const interval = setInterval(() => {
        if (updatedSeconds > 0) {
          updatedSeconds--; // This will now work without error
        } else {
          clearInterval(interval); // Stop the interval when seconds reach 0
          // alert("Time's up!");
          const data = {
            PageNumber: currentPage,
            PageSize: perPage,
            SortOrder: false,
          }; // Show the alert
          AuctionAllFn(data);
        }
      }, 10000);
    }
  };

  function checkAuctionStatus(data) {
    updateTime(data);
  }

  useEffect(() => {
    if (hubConnection) {
      let auctionData = [];
      hubConnection.on("ReceiveBidStatus", (data) => {
        // Group auctions by auctionId
        const auctionGroups = data.reduce((acc, auction) => {
          acc[auction.auctionId] = acc[auction.auctionId] || [];
          acc[auction.auctionId].push(auction);
          return acc;
        }, {});

        // Check each auction group
        Object.entries(auctionGroups).forEach(([auctionId, auctions]) => {
          if (auctions.length === 1) {
            checkAuctionStatus(auctions[0].remainingBidTime);
          }
        });

        auctionData.push(data);
        // Filter for the last auction with remainingBidTime greater than "00:00"
        const lastAuctionWithTime = auctionData
          .filter((auction) => auction.remainingBidTime > "00:00")
          .pop(); // Get the last auction that meets the criteria

        // If we found a valid auction, extract the team information and remaining bid time
        if (lastAuctionWithTime) {
          const lastTeamId = lastAuctionWithTime.teamId; // or any other team-related property
          const lastRemainingBidTime = lastAuctionWithTime.remainingBidTime;

          alert(
            "Last team ID with remaining bid time greater than 00:00:",
            lastTeamId
          );
        }

        data && data?.forEach((oldRest) => {
          setItemList((prev) => {
             const currentList = Array.isArray(prev) ? prev : [];
            return currentList?.map((item) => {
              if (
                oldRest.auctionId === item.auctionId &&
                oldRest.status === "Live"
              ) {
                return { ...item, status: "Live" };
              }
              return item;
            });
          });
        });
      });
      return () => {
        hubConnection.off("ReceiveBidStatus");
      };
    }
  }, [hubConnection, itemList]);

  const onSortEnd = (result) => {
    if (!result.destination) return; // Dropped outside the list
    const newCombinedTeamsArray = Array.from(combinedTeamsArray);
    const [movedItem] = newCombinedTeamsArray.splice(result.source.index, 1);
    newCombinedTeamsArray.splice(result.destination.index, 0, movedItem);
    setCombinedTeamsArray(newCombinedTeamsArray);
  };
  const teamNamesArray = editData?.teamNames
    ? editData.teamNames.split(",").map((name) => name.trim())
    : [];
  const teamNamesImages = editData?.teamImages
    ? editData.teamImages.split(",").map((name) => name.trim())
    : [];

  useEffect(() => {
    const nextPageClick = document.getElementById("pagination-next-page");

    const handleNextPageClick = (event) => {
      setpage((prevPage) => prevPage + 1);
    };

    nextPageClick?.addEventListener(
      "click",
      debounce(handleNextPageClick, 500)
    );

    return () => {
      nextPageClick?.removeEventListener("click", handleNextPageClick);
    };
  }, [filteredData]);

  const AuctionAllFnSearch = async (data) => {
    try {
      const response = await AuctionGetAllDataSearch(data); // Call your API function
      if (response?.data) {
        setItemList(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const clearSearch = () => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    AuctionAllFn(data);
    setSearchText("");
  };

  return (
    <>
      <ModalBox
        show={showView}
        title={
          <>
            <h1 className="heading-dash">View Team</h1>
          </>
        }
        body={
          <>
            <Table bordered>
              <thead>
                <tr>
                  <th
                    className="bg-gray-view"
                    style={{
                      padding: "10px",
                      border: "1px solid #ccc",
                      textAlign: "center",
                    }}
                  >
                    Logo
                  </th>
                  <th
                    className="bg-gray-view"
                    style={{
                      padding: "10px",
                      border: "1px solid #ccc",
                      textAlign: "center",
                    }}
                  >
                    Team Name
                  </th>
                </tr>
              </thead>

              <tbody>
                {teamNamesArray.length > 0 && teamNamesImages.length > 0 ? (
                  teamNamesArray.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          padding: "10px",
                          border: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      >
                        {teamNamesImages[index] ? (
                          <img
                            src={ImageUrl + teamNamesImages[index]}
                            alt={item}
                            style={{ width: "50px", height: "50px" }}
                          />
                        ) : (
                          "No image available"
                        )}
                      </td>
                      <td
                        style={{
                          padding: "10px",
                          border: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      >
                        {item}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No team names or images available</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </>
        }
        footer={
          <>
            <Button variant="secondary" onClick={handleClosed}>
              Close
            </Button>
          </>
        }
      />

      <ModalBox
        show={auctionPlaceModal}
        dialogClassName="custom-modal" 
        headerClassName="custom-modal-header"
        title={
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h1 className="heading-dash text-left">
                  Auction Winnings
                </h1>
              </div>
          
              <div className="col-md-8">
                <div className="row justify-content-between">
                  <div className="col-4 text-center">
                    <div className="mb-2" style={{
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: 'bold'
                    }}>
                      Total Pool
                    </div>
                    <div style={{
                      fontSize: '16px',
                      color: '#000',
                      // fontWeight: 'bold'
                    }}>
                      {(auctionPlacedata?.[0]?.totalPool || 0).toFixed(2)}
                    </div>
                  </div>
                  <div className="col-4 text-center">
                    <div className="mb-2" style={{
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: 'bold'
                    }}>
                      Manager Hold
                    </div>
                    <div style={{
                      fontSize: '16px',
                      color: '#000',
                      // fontWeight: 'bold'
                    }}>
                      {(`${auctionPlacedata?.[0]?.xcuttaTake}%` || 0)}
                    </div>
                  </div>
                  <div className="col-4 text-center">
                    <div className="mb-2" style={{
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: 'bold'
                    }}>
                      Net Pool
                    </div>
                    <div style={{
                      fontSize: '16px',
                      color: '#000',
                      // fontWeight: 'bold'
                    }}>
                      {(auctionPlacedata?.[0]?.netPool || 0).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        body={
          <div className="row">
            {/* Left Side Information */}
            {/* <div className="col-4" style={{ borderRight: '1px solid #ccc', paddingRight: '20px' }}>
        <div className="mb-3">
          <strong>Auction Pool:</strong> 
          <span className="float-right">
            {(auctionPlacedata?.[0]?.totalPool || 0).toFixed(2)}
          </span>
        </div>
        <div className="mb-3">
          <strong>Manager Hold:</strong> 
          <span className="float-right">
            {(auctionPlacedata?.[0]?.managerHold || 0).toFixed(2)}
          </span>
        </div>
        <div className="mb-3">
          <strong>Net Pool:</strong> 
          <span className="float-right">
            {((auctionPlacedata?.[0]?.totalPool || 0) - (auctionPlacedata?.[0]?.managerHold || 0)).toFixed(2)}
          </span>
        </div>
      </div> */}

            {/* Right Side Table */}
            {/* <div className="col-8"> */}
            <Table bordered>
              <thead>
                <tr>
                  {[
                    "Winner Title",
                    "Winner Percentage",
                    "Winner Amount"
                  ].map((header, index) => (
                    <th
                      key={index}
                      className="bg-gray-view"
                      style={{
                        padding: "10px",
                        border: "1px solid #ccc",
                        textAlign: "center",
                      }}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {auctionPlacedata?.map((item, index) => (
                  <tr key={index} style={{ textAlign: 'center' }}>
                    <td>
                      {item?.winnerTitle}
                    </td>
                    <td>
                      {`${item?.winnerPercentage}%`}
                    </td>
                    <td>
                      {(item?.winningAmount || 0).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {/* </div> */}
          </div>
        }
        footer={
          <Button variant="secondary" onClick={handleAuctionPalceBitClosed}>
            Close
          </Button>
        }
      />

      <ModalBox
        show={showEdit}
        onHide={handleClosed}
        title="Update Auction"
        body={
          <>
            <Row>
              <Form.Group as={Col} md={6} controlId="validationCustom02">
                <Form.Label>Auction Name</Form.Label>
                <Form.Control
                  name="auctionName"
                  value={editData?.auctionName}
                  onChange={handelEditSport}
                  className="select-option tournament"
                  required
                  type="text"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter Auction Name.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md={6} className="text-left">
                <Form.Label>Select Contest </Form.Label>
                <InputGroup hasValidation>
                  <Form.Select
                    name="tournamentId"
                    onChange={handleSelectedTurnament}
                    className="select-option tournament"
                    required
                    as="select"
                  >
                    <option>{editData?.tournamentName}</option>
                    {tounamentItem?.map((item) => (
                      <>
                        <option
                          key={item?.tournamentId}
                          value={`${item?.sportId} - ${item.teamId} = ${item?.tournamentId}`}
                        >
                          {item?.tournamentName}
                        </option>
                      </>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Please select a Contest.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              {selectedTournament ? (
                <div>
                  <p>
                    {bracketStatus ? (
                      <h5 className="text-success">Bracket created</h5>
                    ) : (
                      <h5 className="text-danger">No Bracket</h5>
                    )}
                  </p>
                </div>
              ) : (
                ""
              )}

              <p className={`${selectedTournament ? "mt-3 label" : ""}`}>
                {" "}
                {`${selectedTournament ? "Sport Name" : ""}`}{" "}
              </p>
              <Form.Group as={Col} md={12}>
                <p className={`${selectedTournament ? "input-game" : ""}`}>
                  {itemSport?.map(
                    (value) =>
                      value?.sportId == sportIdSelect && value?.sportName
                  )}
                </p>
              </Form.Group>

              {selectedTournament ? (
                <DragDropContext onDragEnd={onSortEnd}>
                  <Droppable droppableId="droppable">
                    {(provided) => (
                      <Col lg={12}>
                        <Table
                          className="table-team border mt-3"
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          <thead>
                            <tr
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                                textAlign: "center",
                              }}
                            >
                              <th
                                style={{
                                  padding: "10px",
                                  border: "1px solid #ccc",
                                  textAlign: "center",
                                }}
                              >
                                S.No
                              </th>
                              {bracketStatus ? <th>Team</th> : <th>Player</th>}
                              <th
                                style={{
                                  padding: "10px",
                                  border: "1px solid #ccc",
                                  textAlign: "center",
                                }}
                              >
                                Name
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                          {/* {teamNamesArray.map((team, index) => */}
                            {combinedTeamsArray.map((team, index) =>
                            
                              team.name !==
                              "The Field (All Remaining Teams)" ? (
                                <Draggable
                                  key={team.id}
                                  draggableId={team.id}
                                  index={index}
                                >
                                  {(provided) => (
                                    <tr
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <td style={{ textAlign: "center" }}>
                                        {index + 1}
                                      </td>
                                      <td
                                        style={{
                                          padding: "10px",
                                          border: "1px solid #ccc",
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          src={ImageUrl + team?.image}
                                          alt={`Image for ${team.name}`}
                                          style={{
                                            width: "50px",
                                            height: "50px",
                                          }}
                                        />
                                      </td>
                                      <td
                                        style={{
                                          padding: "10px",
                                          border: "1px solid #ccc",
                                          textAlign: "center",
                                        }}
                                      >
                                        {team.name}
                                      </td>
                                    </tr>
                                  )}
                                </Draggable>
                              ) : (
                                <tr>
                                  <td style={{ textAlign: "center" }}>
                                    {index + 1}
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px",
                                      border: "1px solid #ccc",
                                      textAlign: "center",
                                    }}
                                  >
                                    <img
                                      src={
                                        auctionTeamsImageData[index]
                                          ? `${ImageUrl}${auctionTeamsImageData[index]}`
                                          : "../image/team-icon.png"
                                      }
                                      alt={`Image for ${team.name}`}
                                      style={{ width: "50px", height: "50px" }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px",
                                      border: "1px solid #ccc",
                                      textAlign: "center",
                                    }}
                                  >
                                    {team.name}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      </Col>
                    )}
                  </Droppable>
                </DragDropContext>
              ) : (
                ""
              )}

              <Form.Group as={Col} md={6}>
                <Form.Label className="mt-3">Auction Start Date</Form.Label>
                <DatePicker
                  format="MM/dd/yyyy hh:mm:ss aa"
                  showMeridian
                  value={startDate}
                  name="startDate"
                  onChange={handelDate}
                  disabledDate={(date) =>
                    date < new Date().setHours(0, 0, 0, 0)
                  }
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please enter Auction Start Date.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md={6}>
                <Form.Label className="mt-3">Bid Time Limit</Form.Label>
                <InputGroup hasValidation>
                  <Form.Select
                    name="bidTime"
                    value={editData?.bidTime}
                    onChange={handelFrom}
                    className="select-option tournament"
                    required
                    as="select"
                  >
                    <option value="" >Select Time Limit</option>
                    <option value={0.5} >0.5 minute</option>
                    <option value={1} >1 minute</option>
                    <option value={2}>2 minutues</option>
                    <option value={3}>3 minutues</option>
                    <option value={4}>4 minutues</option>
                    <option value={5}>5 minutues</option>
                    <option value={6}>6 minutues</option>
                    <option value={7}>7 minutues</option>
                    <option value={8}>8 minutues</option>
                    <option value={9}>9 minutues</option>
                    <option value={10}>10 minutues</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Please add Bid Time Limit.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group as={Col} md={6}>
                <Form.Label className="mt-3">Manager take % </Form.Label>
                <Form.Control
                  name="xcuttaTake"
                  value={editData?.xcuttaTake}
                  onChange={handelAuctionTake}
                  className="select-option tournament"
                  required
                  type="number"
                  placeholder="Enter your cut"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter Xcutta take.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md={6}>
                <Form.Label className="mt-3">Logo image </Form.Label>
                <input
                  type="file"
                  className="form-control"
                  name="auctionImage"
                  onChange={handelImage}
                ></input>
                <br />
              </Form.Group>
              <Form.Group as={Col} md={6}></Form.Group>
              {/* {dataImage === undefined  ? <img src="../image/auction.png" className='imageAuction' width={150}></img>:<img src={ImageUrl+ dataImage} className='imageAuction' alt="Selected" width={100} /> } */}

              {selectedImage ? (
                <img
                  src={selectedImage}
                  alt="Selected"
                  style={{ width: "100px" }}
                />
              ) : (
                <img
                  src={ImageUrl + editData?.auctionImage}
                  style={{ width: "100px" }}
                ></img>
              )}

              <p className="winner-distribution">
                Winner Prize Distribution {100 - editData?.xcuttaTake} %
              </p>

              {allXcuttaPercentage === 0 || allXcuttaPercentage < 0 ? (
                ""
              ) : (
                <>
                  <Form.Label>Total Winners </Form.Label>
                  <Form.Select
                    name="winnerCount"
                    onChange={handelCount}
                    className="select-option tournament"
                    required
                    as="select"
                    defaultValue={editData.winnerCount}
                  >
                    <option value="">Select Winner Count</option>
                    {combinedTeamsArray?.length > 0 &&
                      [...Array(combinedTeamsArray.length).keys()].map(
                        (num) => (
                          <option key={num + 1} value={num + 1}>
                            {num + 1}
                          </option>
                        )
                      )}
                  </Form.Select>
                </>
              )}

              {editData?.winnerCount > 0 && (
                <div className="winner-percentage">
                  <Row>
                    {Array.from({ length: editData.winnerCount }).map(
                      (_, levelIndex) => (
                        <Col md={12} key={levelIndex}>
                          <div>
                            <input
                              type="text"
                              className="input-editable"
                              name={`winnerName-${levelIndex}`}
                              placeholder={`Place ${levelIndex + 1}`}
                              value={winnerTitleList[levelIndex] || ""}
                              onChange={handleTitleChange(levelIndex)} // Update title on change
                              disabled={fnDisabled}
                            />

                            <input
                              name={`winnerPercentage-${levelIndex}`}
                              className="select-option tournament xcuttaTakeinput mb-2"
                              placeholder="Enter Percentage"
                              type="number"
                              value={winnerPercentageList[levelIndex] || ""}
                              onChange={handleWinningPlaceChange(levelIndex)} // Update percentage on change
                            />
                          </div>
                        </Col>
                      )
                    )}
                  </Row>

                  {errorMessage && (
                    <p className="err-message">
                      Please ensure that the total distribution among the
                      winners should be equal to {allXcuttaPercentage}%
                    </p>
                  )}
                </div>
              )}
            </Row>
          </>
        }
        footer={
          <>
            <Button
              variant="primary"
              className="btn-Save me-3"
              onClick={handleUpdate}
            >
              Update
            </Button>
            <Button
              type="button"
              className="btn-Cancel secondary"
              onClick={handleClosed}
            >
              Cancel
            </Button>
          </>
        }
      />

      <ModalDelete
        show={showDeleteModal}
        onHide={handleClosed}
        title="Delete Auction"
        body={<>Are you want to delete the auction?</>}
        footer={
          <>
            <Button variant="danger" onClick={handelDelete}>
              Delete
            </Button>
            <Button variant="secondary" onClick={handleClosed}>
              Close
            </Button>
          </>
        }
      />

      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md={6}>
              <h1 className="heading-dash">Auction</h1>
            </Col>
            <Col md={6} className="text-right">
              <Link to="/SuperAdmin/CreateAuction">
                {" "}
                <Button className="primary button-create-auction">
                  {" "}
                  <icons.Plus class="icon-plus" /> Create New Auction
                </Button>
              </Link>
            </Col>
          </Row>

          <div className="group_data_table auction-list">
            <div class="auction-manager search-input filter d-flex align-items-center">
              <label className="sort-status">Sort By Status</label>

              <Form.Select
                name="select"
                value={selectedOption}
                onChange={handleChangeOption}
                className="me-4"
                required
                as="select"
              >
                <option value={""}>ALL</option>
                <option value={"live"}>Live</option>
                <option value={"upcoming"}>Upcoming</option>
                <option value={"closed"}>Closed</option>
                <option value={"Paused"}>Paused</option>
              </Form.Select>

              <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
              {searchText && (
                <button className="btn btn-clear" onClick={clearSearch}>
                  <span>&times;</span> {/* This represents the close icon */}
                </button>
              )}
            </div>

            {loading && <Loader />}

            <div>
              <DataTable
                title="Sport List"
                columns={columns}
                data={filteredData}
                paginationPerPage={perPage}
                paginationTotalRows={totalRows * 10}
                paginationDefaultPage={currentPage}
                onChangePage={setCurrentPage}
              />
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <label>Rows per page: </label>
                      <select
                        id="itemsPerPage"
                        value={perPage}
                        onChange={handlePerPageChange}
                      >
                        {pageOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {" "}
                        {currentPage} of {totalRows}{" "}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
